import { sampleArray } from 'most';
import { curry3 } from '@most/prelude';

var flippedSampleState = curry3(function (f, stateStream, samplerStream) {
  return sampleArray(f, samplerStream, [stateStream, samplerStream]);
});

var toArray = function toArray(state, samplerStreamEvent) {
  return [state, samplerStreamEvent];
};

export var withState = flippedSampleState(toArray);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-most/es/withState.js
// module id = 871
// module chunks = 0